import { NavSubItemViewModel } from '../nav-sub-item-view-model';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { CompanyDomainModel } from '../../../../../../domainModels/company-domain-model';
import { LocationDomainModel } from '../../../../../../domainModels/location-domain-model';
import { UserDomainModel } from '../../../../../../domainModels/user-domain-model';

@Injectable()
export class ProductsSubNavItemViewModel extends NavSubItemViewModel {
  constructor(
    private companyDomainModel: CompanyDomainModel,
    private locationDomainModel: LocationDomainModel,
    private userDomainModel: UserDomainModel,
    router: Router
  ) {
    super(router);
  }

  private readonly isAdmin$ = this.userDomainModel.hasAdminAccess$;

  public showNavItemAlertIndicator$ = combineLatest([
    this.companyDomainModel.companyConfiguration$,
    this.companyDomainModel.inventoryProvider$,
    this.locationDomainModel.locationId$,
    this.isAdmin$
  ]).pipe(
    map(([config, inventoryProvider, locationId, isAdmin]) => {
      if (!isAdmin) return false;
      return config?.getUnassignedProductCategories(inventoryProvider, locationId)?.length > 0;
    }),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );
}
